// Breadcrumb labels are declared as free strings in each route's `staticData`
// (e.g. `breadCrumb: 'Vehicles'`). Rather than rewrite every route file, the
// English label itself is the key here and `AppBreadcrumbs` translates it with
// a fallback to the raw string — so an unmapped or dynamic label still renders.
export const breadcrumbs = {
  'Fleet Management': 'Fleet Management',
  Vehicles: 'Vehicles',
  'Vehicle Detail': 'Vehicle Detail',
  'Add Vehicle': 'Add Vehicle',
  Drivers: 'Drivers',
  'Driver Detail': 'Driver Detail',
  'Add Driver': 'Add Driver',
  'Data Sharing': 'Data Sharing',
  Developer: 'Developer',
  Demo: 'Demo',
  User: 'User',
  Account: 'Account',
  Billing: 'Billing',
  Notifications: 'Notifications',
  Logout: 'Logout',
  Login: 'Login',
  Users: 'Users',
  'User Detail': 'User Detail',
  'Org Units': 'Org Units',
  Locations: 'Locations',
};

export type BreadcrumbsResources = typeof breadcrumbs;
